import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class CustomAccordion extends UcoastEl {
    static htmlSelector = 'custom-accordion'
    toggle: HTMLElement
    private animationEnd?: (event: TransitionEvent) => void

    constructor() {
        super()
        this.toggle = q.rs('summary', this)

        this.toggle.addEventListener('click', (e) => {
            e.preventDefault()

            const content = this.toggle.nextElementSibling as HTMLElement
            if (!content) return

            const isOpening = !this.hasAttribute('open')
            const startHeight = content.getBoundingClientRect().height
            const reducedMotion = window.matchMedia(
                '(prefers-reduced-motion: reduce)'
            ).matches

            this.toggleAttribute('open')
            this.toggle.setAttribute('aria-expanded', isOpening ? 'true' : 'false')

            if (this.animationEnd) {
                content.removeEventListener('transitionend', this.animationEnd)
                this.animationEnd = undefined
            }
            for (const animation of content.getAnimations()) animation.cancel()

            if (reducedMotion) {
                content.classList.remove('is-animating')
                content.style.height = isOpening ? 'auto' : ''
                return
            }

            content.style.transition = 'none'
            content.style.height = `${startHeight}px`
            content.classList.add('is-animating')
            content.offsetHeight

            content.style.removeProperty('transition')
            content.offsetHeight
            content.style.height = isOpening ? `${content.scrollHeight}px` : '0px'

            const animationEnd = (event: TransitionEvent) => {
                if (event.target !== content || event.propertyName !== 'height') return
                content.removeEventListener('transitionend', animationEnd)
                content.classList.remove('is-animating')
                content.style.height = isOpening ? 'auto' : ''
                this.animationEnd = undefined
            }
            this.animationEnd = animationEnd
            content.addEventListener('transitionend', animationEnd)
        })
    }
}
